import { render, staticRenderFns } from "./PanelSuggestions.vue?vue&type=template&id=3d88fee4&"
import script from "./PanelSuggestions.vue?vue&type=script&lang=js&"
export * from "./PanelSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports